import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Valentina R.',
  age: 34,
  city: 'Rosario',
  text: 'Antes tenía todo anotado en un cuaderno que era un desastre. Desde que implementé este sistema, mi clínica parece otra. Las clientas notan el nivel de profesionalismo y pude aumentar mis precios sin quejas.',
  image: 'https://i.pravatar.cc/150?img=44'
}, {
  name: 'Florencia M.',
  age: 29,
  city: 'CABA',
  text: 'El control de inventario y la ficha de diseño me salvaron la vida. Ya no compro esmaltes repetidos y sé exactamente qué diseño le hice a cada clienta la última vez. ¡Una inversión que se paga sola!',
  image: 'https://i.pravatar.cc/150?img=32'
}, {
  name: 'Carolina S.',
  age: 41,
  city: 'Córdoba',
  text: 'Lo que más me sirvió fue el análisis de rentabilidad por servicio. Me di cuenta que estaba perdiendo plata con algunos tratamientos. Ajusté mis números y mi ganancia mensual creció un 40%.',
  image: 'https://i.pravatar.cc/150?img=10'
}, {
  name: 'Julieta P.',
  age: 31,
  city: 'Mendoza',
  text: 'Las estrategias de captación de clientes VIP funcionan de verdad. Pasé de tener clientas que regateaban el precio a tener la agenda llena de mujeres que valoran el servicio premium que ofrezco.',
  image: 'https://i.pravatar.cc/150?img=5'
}, {
  name: 'Mariana L.',
  age: 38,
  city: 'Mar del Plata',
  text: 'El protocolo de esterilización y los consentimientos informados me dan una tranquilidad enorme. Trabajo mucho más relajada sabiendo que tengo todo el respaldo legal y sanitario en orden.',
  image: 'https://i.pravatar.cc/150?img=49'
}];
export function TestimonialsSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-purple text-white" data-id="element-107">
      <div className="max-w-7xl mx-auto" data-id="element-108">
        <div className="text-center mb-10" data-id="element-109">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold mb-4" data-id="element-110">
            Dueñas de clínicas que ya transformaron su negocio
          </h2>
          <p className="text-brand-roseLight text-lg max-w-2xl mx-auto" data-id="element-111">
            No te quedes solo con nuestras palabras. Mirá lo que dicen las
            profesionales argentinas que ya están usando el sistema.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-112">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 relative ${index === 3 ? 'lg:col-start-2' : ''} ${index === 4 ? 'lg:col-start-3 md:col-start-2' : ''}`} data-id="element-113">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-roseGold/40" data-id="element-114" />
              <div className="flex text-brand-gold mb-4" data-id="element-115">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-116" />)}
              </div>
              <p className="text-gray-100 mb-6 italic leading-relaxed" data-id="element-117">
                "{testimonial.text}"
              </p>
              <div className="flex items-center" data-id="element-118">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full border-2 border-brand-roseGold mr-4" data-id="element-119" />
                <div data-id="element-120">
                  <h4 className="font-bold text-white" data-id="element-121">{testimonial.name}</h4>
                  <p className="text-sm text-brand-roseLight" data-id="element-122">
                    {testimonial.age} años - {testimonial.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}